// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectsPage.test.tsx
import { useNavigate } from "@tanstack/react-router";

import { AskPunttProjectsView } from "../../components/ask-puntt-list/AskPunttProjectsView";
import { useStartNewProjectChat } from "../../utils/useStartNewProjectChat";
import { ASK_V2_PROJECTS_PATH, ASK_V2_PROJECT_PATH } from "../paths";
import { createAskV2Project } from "../services/projects";

export function AskV2ProjectsPage() {
  const navigate = useNavigate();
  const openProject = (projectId: string) => {
    void navigate({
      to: ASK_V2_PROJECT_PATH,
      params: { projectId },
    });
  };
  const { startNewProjectChat, isPending: isStartingProject } =
    useStartNewProjectChat(
      "ask_puntt_v2_projects",
      openProject,
      createAskV2Project,
    );

  return (
    <div
      data-testid="ask-v2-projects-page"
      className="flex min-h-0 flex-1 flex-col"
    >
      <AskPunttProjectsView
        listTo={ASK_V2_PROJECTS_PATH}
        isStartingProject={isStartingProject}
        onOpenProject={openProject}
        onNewProject={() => {
          void startNewProjectChat("v2_projects_launcher");
        }}
      />
    </div>
  );
}
